import { Box, TextField } from "@material-ui/core";
import { FC, useState } from "react";
import { GenericFunction } from "../types/generic.types";
import CustomCard from "./CustomCard";

const BackgroundColor: FC<BackgroundColorProps> = (props) => {
  const { defaultValue = "", onChangeBGColor, onError } = props;
  const [bgColor, setBGColor] = useState(defaultValue);

  const handleChangeColor = (e: any) => {
    let value = e.target.value;
    setBGColor(value);
    onChangeBGColor(value);
    let error = value
      ? !value.startsWith("#")
        ? "Background Color must start with #"
        : value.length !== 7
        ? "Background Color length must be 7"
        : ""
      : "Background is required";

    onError(error);
  };

  return (
    <CustomCard title="Background Color" width="50%">
      <TextField value={bgColor} onChange={handleChangeColor} />
      <Box mt={3}>
        <input type="color" value={bgColor} onChange={handleChangeColor} />
      </Box>
    </CustomCard>
  );
};

interface BackgroundColorProps {
  defaultValue?: string;
  onChangeBGColor: GenericFunction;
  onError: GenericFunction;
}

export default BackgroundColor;
